import DocViewShell from "@/components/DocViewShell";
import FmeaBlueprint from "@/components/blueprints/FmeaBlueprint";

export default function FmeaView() {
  return (
    <DocViewShell
      eyebrow="FMEA Risk Grid"
      eyebrowClass="text-blue-700"
      toolName="FMEA Risk Grid"
      maxWidth="max-w-5xl"
      editPathFn={(id) => `/fmea/${id}`}
      render={(doc) => <FmeaBlueprint doc={doc} />}
    />
  );
}
